function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Modal from 'components/Modal';
import * as constants from '../../../constants';
import * as selectors from '../../../selectors';
import messages from '../../../messages';
import CreateInvitationForm from './CreateInvitationForm';
var _React_PureComponent;
class CreateInvitationModal extends (_React_PureComponent = React.PureComponent) {
    componentDidUpdate(prevProps) {
        const { isInProgress, hasErrors } = this.props;
        if (prevProps.isInProgress && !isInProgress && !hasErrors) {
            this.props.onClose();
        }
    }
    render() {
        return /*#__PURE__*/ _jsxs(Modal, {
            modalId: constants.CREATE_INVITATION_MODAL,
            openModalId: this.props.openModalId,
            styleModifier: "md",
            headerMessage: messages.headers.createInvitation,
            onClose: this.props.onClose,
            children: [
                /*#__PURE__*/ _jsx("p", {
                    className: "text--paragraph mb-7",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.intros.createInvitation))
                }),
                /*#__PURE__*/ _jsx(CreateInvitationForm, _object_spread({}, this.props))
            ]
        });
    }
}
_define_property(CreateInvitationModal, "propTypes", {
    // Explicit props
    adminOrganizationMembership: PropTypes.shape({
        organizationUID: PropTypes.string.isRequired,
        identityUID: PropTypes.string.isRequired,
        isAdmin: PropTypes.bool.isRequired
    }).isRequired,
    openModalId: PropTypes.string,
    // Implicit props
    isInProgress: PropTypes.bool,
    hasErrors: PropTypes.bool,
    // Explicit actions
    onClose: PropTypes.func
});
const mapStateToProps = (state)=>({
        isInProgress: selectors.isCreateInvitationInProgress(state),
        hasErrors: selectors.hasCreateInvitationErrors(state)
    });
const ConnectedCreateInvitationModal = connect(mapStateToProps)(CreateInvitationModal);
export default ConnectedCreateInvitationModal;
